import { isEmpty } from "lodash";

const AnswerDD = ({ answer, question }) => {
  const ddLabels = question?.question_dd_labels;
  const anwerDDLabels = answer?.answer?.other_details?.dd_labels;
  // console.log("answer", answer);

  // if(!ddLabels?.length || isEmpty(anwerDDLabels)) {
  //   return "--";
  // }

  return (
    <div className="border rounded-3 p-3">
      <div className="py-1">
        <div className="d-flex align-items-center gap-10 flex-wrap">
          <h6 className="m-0 fw-sbold themeBlue pb-1">
            {ddLabels[0]}:
          </h6>
          <p className="m-0 themeBlue">
            {anwerDDLabels?.name}
          </p>
        </div>
      </div>
      {ddLabels?.length && !isEmpty(anwerDDLabels) && (
        <div className="py-1">
          <h6 className="m-0 fw-sbold themeBlue pb-1">
          {ddLabels[1]}:
          </h6>
          <p className="m-0 themeBlue">
            {anwerDDLabels?.description}
          </p>
        </div>
      )}
      <div className="py-1 themeBlue">
        {answer?.answer?.answer || "--"}
      </div>
    </div>
  )
}

export default AnswerDD;